import { Box, Fallback, HStack, VStack } from '@cbhq/cds-web/layout';

const SKELETON_ROWS = [0, 1, 2] as const;
const DOMAIN_COL_WIDTH = 220;
const STATUS_COL_WIDTH = 120;
const DATE_COL_WIDTH = 120;
const ROW_GAP = 6;

function DomainClaimsSkeletonRow() {
  return (
    <HStack alignItems="center" gap={ROW_GAP} width="100%">
      <Box width={DOMAIN_COL_WIDTH}>
        <Fallback width={160} height={18} />
      </Box>
      <Box width={STATUS_COL_WIDTH}>
        <Fallback width={90} height={22} />
      </Box>
      <Box width={DATE_COL_WIDTH}>
        <Fallback width={100} height={18} />
      </Box>
    </HStack>
  );
}

export function DomainClaimsSkeleton() {
  return (
    <VStack gap={4} width="100%" testID="domain-claims-skeleton">
      {SKELETON_ROWS.map((row) => (
        <DomainClaimsSkeletonRow key={row} />
      ))}
    </VStack>
  );
}
